import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

/**
 * Sends `withCredentials: true` on all admin auth API calls so HttpOnly MFA trust cookies
 * (`sd_mfa_trust_*`) are stored on MFA completion and sent on the next `signIn` (MFA bypass).
 */
@Injectable()
export class AdminAuthCredentialsInterceptor implements HttpInterceptor {
  private static readonly ADMIN_AUTH_PATH = '/auth/v1/admins/';

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!req.withCredentials && req.url.includes(AdminAuthCredentialsInterceptor.ADMIN_AUTH_PATH)) {
      return next.handle(req.clone({withCredentials: true}));
    }
    return next.handle(req);
  }
}
